/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
window.BidsSummary = {
  _gridApi: null,

  _gridOptions: {
    paginationPageSize: 10,
    headerHeight: 44,
    rowHeight: 44,
    columnDefs: null,
    rowData: null,
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onGridReady(event) {
      return event.api.sizeColumnsToFit();
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    }
  },

  _originalRowNodes: null,

  _renderBidStatus(params) {
    return `<div class='bid-status ${params.data.bid_state.toLowerCase().replace(/ /g, '_')}'>${params.data.bid_state}</div>`;
  },

  _filterBidders(bidders) {
    const filteredBidders = _.filter(bidders, bidder => (bidder.bid_state !== 'Did not submit') && (bidder.state !== 'revoked') && (bidder.state !== 'opted out'));
    return this._gridApi.setGridOption('rowData', filteredBidders);
  },

  _bidValueComparator(valueA, valueB) {
    const comparableValueA = this._localeStringToFloat(valueA);
    const comparableValueB = this._localeStringToFloat(valueB);

    return comparableValueA - comparableValueB;
  },

  _localeStringToFloat(string) {
    const localeStringNumber = string.split(" ")[1];
    const stringNumberWithoutCommas = localeStringNumber.replace(/,/g, '');
    return parseFloat(stringNumberWithoutCommas);
  },

  initializeTable(tableSelector, params) {
    const data = _.map(params, doc => JSON.parse(doc));
    const locales_path = 'v4.tenders.bidding_analysis.bidding_overview';
    const columnDefs =
      [
        { headerName: I18n.t('bidder'), field: 'name', minWidth: 300, pinned: 'left' },
        { headerName: I18n.t('status'), field: 'bid_state', width: 200, cellRenderer: params => this._renderBidStatus(params) },
        { headerName: I18n.t(`${locales_path}.date`), field: 'bid_date', width: 200 },
        { headerName: I18n.t(`${locales_path}.submittals`), field: 'bid_submittals', width: 130 },
        { headerName: `${I18n.t('v4.tenders.bidding_analysis.bidding_overview.coverage')} %`, field: 'bid_coverage', width: 150 },
        { headerName: I18n.t(`${locales_path}.changes`), field: 'bid_changes', width: 130 },
        { headerName: `${I18n.t('v4.tenders.bidding_analysis.bidding_overview.bid_value')}`, field: 'bid_value', cellClass: 'align-right', comparator: _.bind(this._bidValueComparator, this) }
      ];

    this._gridOptions.columnDefs = columnDefs;
    this._gridOptions.rowData = data;
    this._gridOptions.onGridSizeChanged = () => {
      return this._gridApi.sizeColumnsToFit();
    };

    const gridDiv = document.getElementById(tableSelector);
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;

    this._originalRowNodes = this._gridApi.getModel().rowsToDisplay;

    this._filterBidders(data);

    return this._gridApi.sizeColumnsToFit();
  }
};
